/**
 * The cookie-banner choice, shared with GizmoData Cloud (app.gizmodata.com): a cookie on `.gizmodata.com`
 * that the portal's sign-in and sign-up pages read to tell Microsoft Clarity the visitor's choice
 * (backlog #72, 2026-10-08). localStorage alone stays on gizmodata.com. Only analytics consent is shared;
 * the banner is all-or-nothing, so `granted` or `denied`.
 */
export const SHARED_CONSENT_COOKIE = 'gd_consent';

export function writeSharedConsent(granted: boolean): void {
  const host = window.location.hostname;
  const domain = host === 'gizmodata.com' || host.endsWith('.gizmodata.com') ? '; Domain=.gizmodata.com' : '';
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${SHARED_CONSENT_COOKIE}=${granted ? 'granted' : 'denied'}; Path=/; Max-Age=31536000; SameSite=Lax${secure}${domain}`;
}
